<template>
  <q-card flat square>
    <q-table
      :data="featuresTableData"
      :columns="columns"
      row-key="name"
      :pagination.sync="pagination"
      bordered
      dense
      flat
      hide-bottom
      separator="cell"
      square
      class="features-table"
      table-header-class="features-table__header"
    >
      <template v-slot:header-cell-nonRegistered="props">
        <q-th :props="props" auto-width>
          {{ props.col.label }}
        </q-th>
      </template>
      <template v-slot:header-cell-registered="props">
        <q-th :props="props" auto-width>
          {{ props.col.label }}
        </q-th>
      </template>
      <template v-slot:body-cell-name="props">
        <q-td :props="props" no-hover class="name">
          {{ props.row.name }}
        </q-td>
      </template>
      <template v-slot:body-cell-nonRegistered="props">
        <q-td :props="props" no-hover>
          <div v-if="props.row.nonRegistered" :props="props">
            <q-icon name="check" size="30px" color="green"></q-icon>
          </div>
          <div v-else-if="props.row.registered" :props="props">
            <q-icon name="lock" size="30px" color="grey"> </q-icon>
          </div>
          <div v-else><b>Free</b></div>
        </q-td>
      </template>
      <template v-slot:body-cell-registered="props">
        <q-td :props="props" no-hover>
          <div v-if="props.row.registered" :props="props">
            <q-icon name="check" size="30px" color="green"></q-icon>
          </div>
          <div v-else><b>Free</b></div>
        </q-td>
      </template>
    </q-table>
  </q-card>
</template>

<script>
export default {
  name: "FeaturesTable",
  data() {
    return {
      pagination: {
        rowsPerPage: 0,
      },
      columns: [
        {
          name: "name",
          required: true,
          label: "",
          align: "right",
          field: row => row.name,
          format: val => `${val}`,
          sortable: false,
        },
        {
          name: "nonRegistered",
          required: true,
          label: "Non-Registered User",
          align: "center",
          field: "nonRegistered",
          sortable: false,
        },
        {
          name: "registered",
          required: true,
          align: "center",
          label: "Registered User",
          field: "registered",
          sortable: false,
        },
      ],
      featuresTableData: [
        {
          name: "Map View",
          nonRegistered: true,
          registered: true,
        },
        {
          name: "List/Grid View",
          nonRegistered: false,
          registered: true,
        },
        {
          name: "All Filters",
          nonRegistered: false,
          registered: true,
        },
        {
          name: "Detailed Course Profiles",
          nonRegistered: false,
          registered: true,
        },
        {
          name: "Submit Course Ratings & Reviews",
          nonRegistered: false,
          registered: true,
        },
        {
          name: "Create Course Wishlist",
          nonRegistered: false,
          registered: true,
        },
        {
          name: "Track Courses Played",
          nonRegistered: false,
          registered: true,
        },
        {
          name: "Save Custom Notes",
          nonRegistered: false,
          registered: true,
        },
        {
          name: "Premium Data Sets",
          nonRegistered: false,
          registered: true,
        },
        {
          name: "Cost",
        },
      ],
    };
  },
};
</script>
<style lang="scss">
.features-table {
  font-family: Georgia, "Times New Roman", Times, serif;

  &__header th {
    font-size: 20px;
    white-space: normal;
  }

  td:first-child {
    white-space: normal;
  }
}
</style>
